import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  constructor() {
  }
  logError(message: string, stack: string): void {
    // Send errors to a logging server or console
    console.error('LoggingService ' + message);
    console.error(stack);
  }
}
